export const PING_INTERVAL = 20000;
export const RECONNECT_ATTEMPTS = 10;
export const RECONNECT_INTERVAL = 5000;
